import BaseLayer from "./BaseLayer";

class Black extends BaseLayer {

    id = "none";
    label = "None";

    componentDidMount() {
        this.init();
        this.layer.get("drew") ? this.setDrawCompleteState() : this.onDrawComplete();
    }

    onToggleVisible = () =>
        this.props.map.getTarget().style.background = this.state.visible ? "Black" : "White";

    render() {
        return <div style={{color: '#fff'}}>{this.label}</div>
    }

}

export default Black;